import React, { useEffect, useState } from 'react'
import "./publications.css"
import Header from '../../common/header/Header'
import ArticleList from './ArticleList'
import VideoList from './VideoList'
import { Link } from "react-router-dom";

const Publications = () => {
  const [articles, setArticles] =useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 8;
  
  

  useEffect(() => {
    // Fetch data from JSON file in the public folder
    fetch("/articles.json")
      .then((response) => response.json())
      .then((data) => {
        // Filter articles where type is 'Publication'
        const filteredArticles = data.filter(article => article.type === "Publication");
        setArticles(filteredArticles);
      })
      .catch((error) => {
        console.error("Error fetching the articles data: ", error);
      });
  }, []);

  // Logic for pagination
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);

  const totalPages = Math.ceil(articles.length / articlesPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
    <Header/>
    <section id="blog" className="blog">
    <div className="container " data-aos="fade-up">

      <div className="row">

        <div className="col-lg-8 entries">
        <ArticleList/>
        <VideoList/>
        </div>

        <div className="col-lg-4">

          <div className="sidebar">

            <h3 className="sidebar-title">Search</h3>
            <div className="sidebar-item search-form">
              <form action="">
                <input type="text"/>
                <button type="submit"><i className="bi bi-search"></i></button>
              </form>
            </div>
            <Link to="/signin" ><h5 className="sidebar-title">UPLOAD </h5></Link>

            <h3 className="sidebar-title">Categories</h3>
            <div className="sidebar-item categories">
              <ul>
                <li><a href="#">General <span>(13)</span></a></li>
                <li><a href="#">FRT<span>(6)</span></a></li>
                <li><a href="#">FHL<span>(4)</span></a></li>
                <li><a href="#">MLIMI Radio<span>(3)</span></a></li>

              </ul>
            </div>

            <h3 className="sidebar-title">Recent Posts</h3>
            <div className="sidebar-item recent-posts">
            <div className="post-item clearfix">
                <img src="./image/blog/farmgateprices.png" alt=""/>
                <h4><a href="blog-single.html">Farm Gate Prices</a></h4>
                <time datetime="2020-01-01">April 25, 2024 </time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/singlepublications/cattles.jpg" alt=""/>
                <h4><a href="blog-single.html">FRT Supporting cattle Farmers</a></h4>
                <time datetime="2020-01-01">18 March, 2024 </time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/blog-recent-1.jpg" alt=""/>
                <h4><a href="blog-single.html">19th National Agriculture Fair</a></h4>
                <time datetime="2020-01-01">August 24, 2023 </time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/blog-recent-2.jpg" alt=""/>
                <h4><a href="blog-single.html">FRT And NPC Have Signed A Memo Of Understanding(MoU)</a></h4>
                <time datetime="2020-01-01">July 23, 2023</time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/blog-recent-3.jpg" alt=""/>
                <h4><a href="blog-single.html">Happy Africa Day</a></h4>
                <time datetime="2020-01-01">May 25, 2023</time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/blog-recent-4.jpg" alt=""/>
                <h4><a href="blog-single.html">Trainings</a></h4>
                <time datetime="2020-01-01">Jan 1, 2023</time>
              </div>

              <div className="post-item clearfix">
                <img src="./image/blog/blog-recent-5.jpg" alt=""/>
                <h4><a href="blog-single.html">Mlimi Radio Launch</a></h4>
                <time datetime="2020-01-01">March 25, 2023</time>
              </div>

            </div>

            <h3 className="sidebar-title">Tags</h3>
            <div className="sidebar-item tags">
              <ul>
                <li><a href="#">ICT plartforms</a></li>
                <li><a href="#">mlimi App</a></li>
                <li><a href="#">services</a></li>
                <li><a href="#">Mlimi Radio</a></li>
                <li><a href="#">Design</a></li>
                <li><a href="#">Offices</a></li>
                <li><a href="#">Innovations</a></li>
                <li><a href="#">Studio</a></li>

                <li><a href="#">Tips</a></li>
                <li><a href="#">Marketing</a></li>
              </ul>
            </div>

          </div>

        </div>

      </div>

    </div>
  </section>
    
    </>
  )
}

export default Publications